import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";


import { customUseEffect } from "@common";

import { setCompetencySearchTerm } from "@features";

const useCompetencyFrameworkConfigController = ({
  showAdd,
  setShowAdd,
  showViewDetails,
  setShowViewDetails,
  viewMode,
  setViewMode,
  displayRows = [],
  visibleStatusItems = [],
  statusItems = [],
  rowsByStatus = {},
  effectiveVisibleStatuses = [],
  visibleStatuses = [],
  setVisibleStatuses,
  renderView,
}) => {
  const [columnAnchorEl, setColumnAnchorEl] = useState(null);
  const competencyFramework = useSelector((state) => state.competencyFramework);
  const [searchTerm, setSearchTerm] = useState(competencyFramework?.searchCompetencyData);
  const dispatch = useDispatch();

  // Sync when Redux state changes externally
  customUseEffect(() => {
    setSearchTerm(competencyFramework?.searchCompetencyData || "");
  }, [competencyFramework?.searchCompetencyData]);

  return {
    heading: "Competency Framework",
    compact: showViewDetails,
    newBtn: {
      showAdd,
      setShowAdd,
    },
    search: {
      searchTerm,
      handleSearch: (value) => {
        setSearchTerm(value);
        dispatch(setCompetencySearchTerm(value));
      },
      handleSearchClear: () => {
        setSearchTerm("");
        dispatch(setCompetencySearchTerm(""));
      },
      placeholder: "Search Competency...",
    },
    view: {
      viewMode,
      setViewMode,
      data: displayRows,
    },
    column: {
      title: "Choose Competency Statuses",
      columnAnchorEl,
      setColumnAnchorEl,
      visibleStatusItems,
      statusItems,
      heading: "Show Competency Statuses",
      rowsByStatus,
      effectiveVisibleStatuses,
      visibleStatuses,
      setVisibleStatuses,
    },
    kanbanView: {
      renderFeatureView: renderView,
    },
  };
};

export default useCompetencyFrameworkConfigController;